import React, { useCallback } from 'react';
import { useObservable } from 'react-use-observable';

import { Button, Typography } from 'antd';

import PermissionHide from 'v2/components/Shared/PermissionHide';
import ordersService from 'v2/services/orders';

import { Icon } from '@eduzz/ui-antd-theme';

import { Export } from './Export';

export const Details = () => {
  const openModalTrackingCodes = useCallback(() => ordersService.openModalTrackingCodes(), []);
  const [totalItems] = useObservable(() => ordersService.getTotalItems(), []);
  const [loading] = useObservable(() => ordersService.isLoading(), []);

  if (loading) {
    return null;
  }

  return (
    <div id='orders-details' className='mb-4 flex flex-wrap items-center justify-between gap-4'>
      <Typography.Text id='orders-result-button-label' strong>
        {totalItems || 0} entregas
      </Typography.Text>

      <div className='flex flex-wrap gap-2'>
        <PermissionHide action='myeduzz:minhas-entregas:editar'>
          <Button
            id='batch-screening'
            color='default'
            variant='filled'
            disabled={!totalItems}
            onClick={openModalTrackingCodes}
            icon={<Icon.ChevronsRight size={16} />}
          >
            Rastreio em Lote
          </Button>
        </PermissionHide>
        <PermissionHide action='myeduzz:minhas-entregas:exportar'>
          <Export />
        </PermissionHide>
      </div>
    </div>
  );
};
